module.exports = __webpack_public_path__ + "img/sprinkle-25.dffa7ad7.webp";